import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';


const Endpoint = '/api/getParticipante/';


const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getParticipanteCodigo = async (codigo) => {
    try {
        const response = await api.get(`${Endpoint}${codigo}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener el participnate:', error);
        throw error;
    }
};
export default getParticipanteCodigo;